'use client'

import { useEffect, useState } from 'react'

export function useIsApp(): { isApp: boolean | undefined } {
  const [isApp, setIsApp] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    let check = false
    if (window.nativePushStatus || window.nativeRequestPushToken) {
      check = true
    }
    // Uncomment next line to for testing NewHeader, otherwise it will only be true in the downloaded app
    // check = true
    if (check) {
      setIsApp(true)
    } else {
      setIsApp(false)
    }
  }, [])
  return { isApp }
}
